import { useSelector } from 'react-redux';

import { Headline, Text } from '~components/Typography';
import { usePaywallContext } from '~context/paywall';
import { PaymentReason, PaymentReasonType } from '~features/annals';
import { useHasSubscription } from '~features/tags';
import { useCurrentBot } from '~hooks/useCurrentBot';
import { useTranslations } from '~i18n/hooks';
import { Loader } from '~shared/ui/atoms';
import { ButtonTertiary } from '~shared/ui/molecules';
import { chatVideoGenerationSelectors } from '~store/chat-video-generation';

import { LoaderWrapper, Wrapper } from './styles';

export const ChatImageGenerationLoader = ({
	recipientId,
}: {
	recipientId: string;
}) => {
	const t = useTranslations('Chats.imageGeneration');
	const [hasSubscription] = useHasSubscription();
	const { openPaywall } = usePaywallContext();

	const {
		bot: { generations = [] },
	} = useCurrentBot({ recipientId });
	const isGenerationInProgressIsVideo = useSelector(
		chatVideoGenerationSelectors.getMessageIdByTag(
			generations[generations.length - 1]
		)
	);

	return generations.length > 0 ? (
		<Wrapper>
			<LoaderWrapper pro={hasSubscription}>
				<Loader size={64} />
			</LoaderWrapper>
			<Headline size="S">
				{isGenerationInProgressIsVideo
					? t('loaderTitleVideo')
					: t('loaderTitle')}
			</Headline>
			<Text size="S">
				{hasSubscription
					? t('loaderSubtitleWithSubscription')
					: t('loaderSubtitle')}
			</Text>
			{hasSubscription ? null : (
				<>
					<Headline size="XS" color="semi-transparent">
						{t('or')}
					</Headline>
					<ButtonTertiary
						onClick={openPaywall({
							prefer: 'subscription',
							reason: PaymentReason.ImageGeneration,
							reasonType: PaymentReasonType.Chat,
							botClientId: recipientId,
						})}
					>
						{t('becomePro')}
					</ButtonTertiary>
				</>
			)}
		</Wrapper>
	) : null;
};
